import * as React from 'react';
import { readGlobal, Modal, ModalProps, Translate } from 'oasis-os-common';
import { redirectURL } from 'oasis-os-utils';
import { IonButton, IonButtons, IonTitle } from '@ionic/react';
import { isPlatform } from '@ionic/core';
import { smartRedirectConfig } from '../../types';
import './style.css';
import { Icon } from 'oasis-os-theming';
import { useState } from 'react';

type functionType = () => void;
type SmartFC = {
  onContinue: functionType;
};

const SmartRedirectModal: React.FC<SmartFC> | void = ({ onContinue }: SmartFC) => {
  const smartRedirectURLConfig = readGlobal(
    '$.global.value.service.smartRedirect',
  ) as smartRedirectConfig;
  const smartRedirectFC = readGlobal(
    '$.global.value.functionalConfig.features.smartRedirect',
  ) as smartRedirectConfig;

  const smartRedirect = (smartRedirectURL: smartRedirectConfig) => {
    if (isPlatform('ios') && smartRedirectURL?.ios) {
      redirectURL(smartRedirectURL?.ios);
    }
    if (isPlatform('android') && smartRedirectURL?.android) {
      redirectURL(smartRedirectURL?.android);
    }
  };

  const [modalState, setModalState] = useState(true);
  const modalProps: ModalProps = {
    ionModal: {
      isOpen: modalState,
      showBackdrop: true,
      backdropDismiss: false,
      cssClass: 'auto-height',
      presentation: 'sheet',
      className: 'pwa__smart-redirect-model',
    },
    modalHeader: (
      <IonTitle>
        <Translate id="general.smartRedirect.modalDescription" />
      </IonTitle>
    ),
  };

  return smartRedirectFC.actionModal ? (
    <div>
      <Modal {...modalProps}>
        <div className="pwa__smart-redirect-model__content">
          <button
            className="pwa__smart-redirect-model__content__button"
            onClick={() => {
              smartRedirect(smartRedirectURLConfig);
            }}
            data-testid="smart-redirect"
          >
            <Icon
              icon={'appIconNew'}
              className="pwa__smart-redirect-model__content__button--icon-start"
            ></Icon>
            <div className="pwa__smart-redirect-model__content__button-desc-con">
              <div className="pwa__smart-redirect-model__content__button-desc-con__title">
                <Translate id="general.smartRedirect.brandAppTitle" />
              </div>
              <div className="pwa__smart-redirect-model__content__button-desc-con__desc">
                <Translate id="general.smartRedirect.brandAppDesc" />
              </div>
            </div>
            <Icon
              icon={'caretRight'}
              className="pwa__smart-redirect-model__content__button--icon-end"
            ></Icon>
          </button>
          <button
            className="pwa__smart-redirect-model__content__button"
            onClick={() => {
              onContinue();
              setModalState(false);
            }}
            data-testid="continue-web"
          >
            <Icon
              icon={'defaultWebBrowser'}
              className="pwa__smart-redirect-model__content__button--icon-start"
            ></Icon>
            <div className="pwa__smart-redirect-model__content__button-desc-con">
              <Translate id="general.smartRedirect.webBrowserTitle" />
            </div>
            <Icon
              icon={'caretRight'}
              className="pwa__smart-redirect-model__content__button--icon-end"
            ></Icon>
          </button>
          <p className="pwa__smart-redirect-model__content__bottom">
            <Translate id="general.smartRedirect.modalFooterDesc" />
          </p>
        </div>
      </Modal>
    </div>
  ) : (
    smartRedirect(smartRedirectURLConfig)
  );
};
export default SmartRedirectModal;
